import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css'],
})
export class SuccessComponent implements OnInit {
  email: string = '';
  constructor(public route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap
      .pipe(map(() => window.history.state))
      .subscribe({
        next: (val) => {
          this.email = val.email;
        },
      });
  }

}
